<div class="countdown" [class.countdown--compact]="compact()" role="timer">
  <span class="countdown__label">{{ label() }}</span>
  <span class="countdown__value">{{ remaining() }}</span>
</div>
